import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import request, { withRetry as retry } from '@flowio/request';

var ShopifySessionClient = /*#__PURE__*/function () {
  function ShopifySessionClient(_ref) {
    var apiBaseUri = _ref.apiBaseUri;

    _classCallCheck(this, ShopifySessionClient);

    this.apiBaseUri = apiBaseUri;
  }

  _createClass(ShopifySessionClient, [{
    key: "createSession",
    value: function createSession(shop, callback) {
      retry(request.anonymous, {
        haltOnStatus: [404, 422]
      })({
        url: "".concat(this.apiBaseUri, "/shopify/shops/").concat(encodeURIComponent(shop), "/sessions"),
        data: {},
        method: 'POST'
      }, callback);
    }
  }, {
    key: "getSession",
    value: function getSession(sessionId, callback) {
      retry(request.anonymous, {
        haltOnStatus: [404, 422]
      })({
        url: "".concat(this.apiBaseUri, "/sessions/shopify/").concat(sessionId),
        method: 'GET'
      }, callback);
    }
  }, {
    key: "resetSession",
    value: function resetSession(sessionId, form, callback) {
      retry(request.anonymous, {
        haltOnStatus: [404, 422]
      })({
        url: "".concat(this.apiBaseUri, "/sessions/shopify/").concat(sessionId, "/reset"),
        method: 'PUT',
        data: pickBy(form, identity),
        envelope: true
      }, callback);
    }
  }, {
    key: "clearSession",
    value: function clearSession(sessionId, callback) {
      retry(request.anonymous, {
        haltOnStatus: [404, 422]
      })({
        url: "".concat(this.apiBaseUri, "/sessions/shopify/").concat(sessionId, "/clear"),
        method: 'PUT',
        data: {},
        envelope: true
      }, callback);
    }
  }]);

  return ShopifySessionClient;
}();

export { ShopifySessionClient as default };
//# sourceMappingURL=shopify.js.map